// SessionJobs.jsx
import { FaBriefcase } from "react-icons/fa";
import "./SessionJobs.css";

const jobsData = [
  {
    id: "gioi-thieu-thuc-tap",
    title: "Giới Thiệu Thực Tập",
    image: "/images/home/jobs/job1.webp",
  },
  {
    id: "gioi-thieu-viec-lam",
    title: "Giới Thiệu Việc Làm",
    image: "/images/home/jobs/job2.webp",
  },
  {
    id: "nha-tuyen-dung",
    title: "Nhà Tuyển Dụng",
    image: "/images/home/jobs/job3.webp",
  },
];

const SessionJobs = () => (
  <section className="jobs">
    <div className="jobs__container">
      {/* Icon */}
      <div className="jobs__icon">
        <FaBriefcase />
      </div>

      {/* Title */}
      <h2 className="jobs__title">THỰC TẬP – VIỆC LÀM</h2>

      {/* Cards */}
      <div className="jobs__cards">
        {jobsData.map(({ id, title, image }) => (
          <div
            key={id}
            className="jobs__card"
          >
            <div className="jobs__card-image-wrapper">
              <img
                src={image}
                alt={title}
                className="jobs__card-image"
                loading="lazy"
              />
            </div>
            <div className="jobs__card-text-wrapper">
              <h3 className="jobs__card-title">{title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SessionJobs;
